/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { stripHtmlToText } from "./faq-structured-data.utils";

import type { FeedItem } from "@components/elements/molecules/feed-cards/feed-card.types";

/**
 * Alt text for a feed image. The origins disagree on the field name — hygraph indexes `altText`,
 * cms indexes `alt`, and forum sends neither.
 */
export const getFeedImageAltText = (item: FeedItem): string | undefined =>
	item.image?.altText || item.image?.alt || undefined;

/**
 * Plain-text title for a feed item, safe for `alt` / `aria-label` / analytics labels.
 *
 * The forum origin omits `titleText` and sends a plain `title`; the cms origin sets `titleText` to
 * the same value as `title`, which its own ingest documents as possibly HTML. So tags are stripped
 * either way rather than trusting the field name.
 */
export const getFeedTitleText = (item: FeedItem): string => stripHtmlToText(item.titleText || item.title);
